import { useState, useEffect } from 'react';

const LOGO_URL = '/images/logo.png';
const navLinks = ['Home', 'About', 'Contact'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#FAF8F5]/96 backdrop-blur-sm border-b border-[#E8DDD0]'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-8 lg:px-16 py-4">
        <button
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => scrollTo('home')}
          aria-label="Go to top"
        >
          <img
            src={LOGO_URL}
            alt="Mastro Family Farm Logo"
            className="h-11 w-11 object-contain rounded-full ring-2 ring-[#C8973A]/40"
          />
          <div className="text-left">
            <p
              className={`font-serif font-bold text-base leading-tight transition-colors duration-500 ${
                scrolled ? 'text-[#3A2A1A]' : 'text-white drop-shadow'
              }`}
            >
              Mastro Family Farm
            </p>
            <p
              className={`text-xs transition-colors duration-500 ${
                scrolled ? 'text-[#8B7355]' : 'text-white/80 drop-shadow'
              }`}
            >
              Est. 2026 &nbsp;&middot;&nbsp; Sowing in Faith
            </p>
          </div>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link)}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-[#3A2A1A] hover:text-[#2C4A3B]'
                  : 'text-white/90 hover:text-white drop-shadow'
              }`}
            >
              {link}
            </button>
          ))}
        </div>

        <button
          className={`md:hidden text-2xl cursor-pointer w-8 h-8 flex items-center justify-center ${
            scrolled ? 'text-[#3A2A1A]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu-3'}-line`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#FAF8F5] border-t border-[#E8DDD0] px-8 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link)}
              className="text-sm font-medium text-[#3A2A1A] hover:text-[#2C4A3B] cursor-pointer whitespace-nowrap text-left transition-colors"
            >
              {link}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
